import type { ReactNode } from "react";
import React from "react";
import IconEdit from "../../../icons/IconEdit";
import IconShare from "../../../icons/IconShare";
import IconTrash from "../../../icons/IconTrash";
import IconClose from "../../../icons/IconClose";
import IconDocument from "../../../icons/IconDocument";
import IconCamera from "../../../icons/IconCamera";
import IconImage from "../../../icons/IconImage";
import IconScan from "../../../icons/IconScan";
import IconEye from "../../../icons/IconEye";
import IconCheck from "../../../icons/IconCheck";

export const AUTO_ICON_MAP: Record<string, ReactNode> = {
  edit: <IconEdit />,
  share: <IconShare />,
  delete: <IconTrash />,
  remove: <IconTrash />,
  cancel: <IconClose />,
  close: <IconClose />,
  deny: <IconClose />,
  view: <IconEye />,
  preview: <IconEye />,
  open: <IconEye />,
  document: <IconDocument />,
  download: <IconDocument />,
  save: <IconDocument />,
  upload: <IconDocument />,
  attach: <IconDocument />,
  image: <IconImage />,
  gallery: <IconImage />,
  "photo-library": <IconImage />,
  camera: <IconCamera />,
  "take-photo": <IconCamera />,
  scan: <IconScan />,
  confirm: <IconCheck />
};

export const getAutoIconForId = (id: string): ReactNode | undefined => {
  return AUTO_ICON_MAP[id];
};
